import { createContext } from 'react';

export const WebSocketContext = createContext({});

const WebSocketContextProvider = ({ client, children }) => {
  return (
    <WebSocketContext.Provider value={client}>
      {children}
    </WebSocketContext.Provider>
  );
};

export default WebSocketContextProvider;
